@if (isHb) {
  <div class="tw-ml-6 tw-inline-flex tw-w-full tw-items-center tw-rounded-2xl tw-bg-azure tw-py-1">
    <ia-icon
      name="nhb:bulb_nhb"
      class="tw-m-4 tw-w-4 tw-shrink-0 tw-text-cerulean-3"
      color="#0a7e9e"
    />
    <p class="tw-max-w-2xl tw-text-hb-base tw-text-hb-brand-1100">
      {{ 'screens.terminationInformation.panel.contact' | translate }}
    </p>
  </div>
}

@if (!isHb) {
  <p class="tw-mt-7.5 hb-group:tw-mx-6 hb-group:tw-text-slate-gray md:tw-mt-0">
    {{ 'screens.terminationInformation.requiredFields' | translate }}
  </p>
}
<ia-panel class="tw-mt-7.5 hb-group:tw-mx-6">
  <div header class="tw-w-full tw-justify-between mb-group:tw-flex mb-group:tw-flex-row">
    <span>{{ 'screens.terminationInformation.panel.title' | translate }}</span>
    @if (isHb) {
      <p class="tw-mt-7.5 tw-text-hb-base tw-font-normal hb-group:tw-text-slate-gray md:tw-mt-0">
        {{ 'screens.terminationInformation.requiredFields' | translate }}
      </p>
    }
  </div>

  <div content>
    <form
      [formGroup]="terminationInformationForm"
      class="tw-px-7.5 tw-pb-7.5 mb-group:tw-pt-10 hb-group:tw-px-0 hb-group:tw-text-midnight-green"
    >
      @if (!isHb) {
        <div class="tw-inline-flex tw-items-center">
          <ia-icons name="information_white" class="tw-mr-4 tw-w-8 tw-shrink-0" color="#008854" />
          <p class="tw-font-semibold hb-group:tw-text-cerulean">
            {{ 'screens.terminationInformation.panel.contact' | translate }}
            <button
              data-test-id="'btn-contact-us"
              type="button"
              class="tw-cursor-pointer tw-underline"
              (click)="onContactUs()"
              (keydown.enter)="onContactUs()"
            >
              {{ 'screens.terminationInformation.panel.contactUs' | translate }}
            </button>
          </p>
        </div>
      }

      <div class="tw-mt-7">
        <label
          for="input-termination-information-contract-type-banking-product"
          class="mb-group:tw-font-bold"
          >{{ 'screens.terminationInformation.panel.contractType.label' | translate }}</label
        >
        <div class="hb-group:tw-flex-col hb-group:md:tw-flex">
          <div class="tw-mt-4 tw-flex tw-items-center">
            <input
              [value]="bankingProductValue"
              iaSharedRadio
              type="radio"
              formControlName="contractType"
              name="contractType"
              id="input-termination-information-contract-type-banking-product"
              data-test-id="input-termination-information-contract-type-banking-product"
            />
            <label
              for="input-termination-information-contract-type-banking-product"
              class="tw-ml-3 tw-cursor-pointer hb-group:tw-text-hb-base"
              >{{
                'screens.terminationInformation.panel.contractType.bankingProduct' | translate
              }}</label
            >
          </div>

          <div class="tw-flex tw-items-center mb-group:tw-mt-5 hb-group:tw-mt-2">
            <input
              [value]="insuranceValue"
              iaSharedRadio
              type="radio"
              formControlName="contractType"
              name="contractType"
              id="input-termination-information-contract-type-insurance"
              data-test-id="input-termination-information-contract-type-insurance"
            />
            <label
              for="input-termination-information-contract-type-insurance"
              class="tw-ml-3 tw-cursor-pointer hb-group:tw-text-hb-base"
              >{{
                'screens.terminationInformation.panel.contractType.insurance' | translate
              }}</label
            >
          </div>
        </div>
      </div>

      @if (contractType.value) {
        <div class="tw-mt-7">
          <label
            for="input-termination-information-termination-type-banking-product"
            class="mb-group:tw-font-bold"
            >{{ 'screens.terminationInformation.panel.terminationType.label' | translate }}</label
          >
          <div class="hb-group:tw-flex-col hb-group:md:tw-flex">
            <div class="tw-mt-4 tw-flex tw-items-center">
              <input
                [value]="withdrawValue"
                iaSharedRadio
                type="radio"
                formControlName="terminationType"
                name="terminationType"
                id="input-termination-information-termination-type-banking-product"
                data-test-id="input-termination-information-termination-type-banking-product"
              />
              <label
                for="input-termination-information-termination-type-banking-product"
                class="tw-ml-3 tw-cursor-pointer hb-group:tw-text-hb-base"
              >
                @if (contractType.value === bankingProductValue) {
                  {{
                    'screens.terminationInformation.panel.terminationType.withdrawBankingProduct'
                      | translate
                  }}
                } @else {
                  {{
                    'screens.terminationInformation.panel.terminationType.withdrawInsurance'
                      | translate
                  }}
                }
              </label>
            </div>

            <div class="tw-flex tw-items-center mb-group:tw-mt-5 hb-group:tw-mt-2">
              <input
                [value]="terminateValue"
                iaSharedRadio
                type="radio"
                formControlName="terminationType"
                name="terminationType"
                id="input-termination-information-termination-type-insurance"
                data-test-id="input-termination-information-termination-type-insurance"
              />
              <label
                for="input-termination-information-termination-type-insurance"
                class="tw-ml-3 tw-cursor-pointer hb-group:tw-text-hb-base"
                >{{
                  'screens.terminationInformation.panel.terminationType.terminate' | translate
                }}</label
              >
            </div>
          </div>
          @if (terminationType.touched && terminationType.hasError('required')) {
            <ia-resil-contrats-error-message
              [message]="
                'screens.terminationInformation.panel.terminationType.error.required' | translate
              "
            />
          }
        </div>
      }

      <div class="tw-mt-7.5">
        <label
          class="tw-font-bold hb-group:tw-text-hb-sm hb-group:tw-font-medium"
          for="input-termination-information-contract"
          >{{ 'screens.terminationInformation.panel.contract.label' | translate }}</label
        >
        <ia-listbox2
          [placeholder]="'screens.terminationInformation.panel.contract.placeholder' | translate"
          class="tw-mt-2.5 tw-w-full hb-group:tw-mt-0 hb-group:tw-flex hb-group:tw-w-full hb-group:tw-items-center hb-group:tw-justify-center hb-group:tw-rounded-xl hb-group:tw-border hb-group:tw-border-silver hb-group:tw-p-3 hb-group:tw-text-hb-md md:tw-w-75 hb-group:md:tw-w-1/2"
          formControlName="contract"
        >
          @for (item of (products$ | async) || []; track $index) {
            <ia-listbox2-option [value]="item.value">
              {{ item.value }}
            </ia-listbox2-option>
          }
        </ia-listbox2>
        @if (contract.touched && contract.hasError('required')) {
          <ia-resil-contrats-error-message
            [message]="'screens.terminationInformation.panel.contract.error.required' | translate"
          />
        }
      </div>

      @if (contract.value === other) {
        <div class="tw-mt-7.5">
          <label
            class="tw-font-bold hb-group:tw-text-hb-sm hb-group:tw-font-medium"
            for="input-termination-information-contract-name"
            >{{ 'screens.terminationInformation.panel.contractName.label' | translate }}</label
          >
          <input
            [error]="contractName!.touched && contractName!.invalid"
            iaInput
            id="input-termination-information-contract-name"
            data-test-id="input-termination-information-contract-name"
            class="tw-w-full focus-visible:focus-visible:tw-outline-none hb-group:tw-mt-0 hb-group:tw-w-full md:tw-w-75 hb-group:md:tw-w-1/2"
            formControlName="contractName"
            mask="A*"
            [patterns]="specialCharactersNotAllowed"
            [dropSpecialCharacters]="false"
            [placeholder]="
              'screens.terminationInformation.panel.contractName.placeholder' | translate
            "
          />
          @if (contractName.touched && contractName.hasError('required')) {
            <ia-resil-contrats-error-message
              [message]="
                'screens.terminationInformation.panel.contractName.error.required' | translate
              "
            />
          }
        </div>
      }

      <div class="tw-mt-7.5">
        <div class="tw-block tw-items-center sm:tw-inline-flex">
          <label
            class="tw-font-bold hb-group:tw-text-hb-sm hb-group:tw-font-medium"
            for="input-termination-information-contract-number"
            >{{ 'screens.terminationInformation.panel.contractNumber.label' | translate }}</label
          >
          <ia-tooltip
            colorClass="tw-text-gray hb-group:tw-text-midnight-green hb-group:tw-w-5 hb-group:tw-h-5"
            tooltipContainerClass="tw-border tw-border-platinum tw-absolute tw--left-8 tw-w-56 tw-rounded-md tw-bg-white tw-px-4 tw-py-5 tw-text-left tw-text-sm tw-text-gray"
            class="tw-ml-2.5"
          >
            {{ 'screens.terminationInformation.panel.contractNumber.tooltip' | translate }}
          </ia-tooltip>
        </div>
        <input
          [error]="contractNumber!.touched && contractNumber!.invalid"
          iaInput
          id="input-termination-information-contract-number"
          data-test-id="input-termination-information-contract-number"
          class="tw-w-full focus-visible:focus-visible:tw-outline-none hb-group:tw-mt-0 hb-group:tw-w-full md:tw-w-75 hb-group:md:tw-w-1/2"
          formControlName="contractNumber"
          mask="A*"
          [patterns]="specialCharactersNotAllowed"
          [placeholder]="
            'screens.terminationInformation.panel.contractNumber.placeholder' | translate
          "
        />
        @if (contractNumber.touched && contractNumber.hasError('required')) {
          <ia-resil-contrats-error-message
            [message]="
              'screens.terminationInformation.panel.contractNumber.error.required' | translate
            "
          />
        }
      </div>

      @if (terminationType.value === terminateValue) {
        <div class="tw-mt-7.5">
          <label
            class="tw-font-bold hb-group:tw-text-hb-sm hb-group:tw-font-medium"
            [ngClass]="{ 'mb-group:tw-text-gray': contractType.value === bankingProductValue }"
            for="input-termination-information-termination-date"
            >{{ 'screens.terminationInformation.panel.terminationDate.label' | translate }}</label
          >
          @if (contractType.value === insuranceValue) {
            <ia-datepicker
              class="tw-mt-1.5 tw-block tw-w-full hb-group:tw-mt-0 md:tw-w-75 hb-group:md:tw-w-1/2"
              [inputClass]="{
                '!tw-px-4 tw-text-gray mb-group:tw-shadow-inner focus-visible:focus-visible:tw-outline-none': true,
              }"
              [inputConfig]="{
                containerClass:
                  'ia-datepicker tw-rounded-[3px]' +
                  (terminationDate.invalid && terminationDate.touched
                    ? 'tw-border tw-border-tomato tw-rounded-[3px]'
                    : ''),
              }"
              formControlName="terminationDate"
              id="input-termination-information-insurance-termination-date"
            />
          }
          @if (contractType.value === bankingProductValue) {
            <input
              [error]="terminationDate!.touched && terminationDate!.invalid"
              class="tw-w-full focus-visible:focus-visible:tw-outline-none disabled:tw-cursor-auto disabled:tw-bg-seasalt disabled:tw-text-gray hb-group:tw-mt-0 hb-group:tw-w-full md:tw-w-75 hb-group:md:tw-w-1/2"
              formControlName="terminationDate"
              iaInput
              id="input-termination-information-termination-date"
              data-test-id="input-termination-information-termination-date"
            />
          }
          @if (terminationDate.touched && terminationDate.hasError('required')) {
            <ia-resil-contrats-error-message
              [message]="
                'screens.terminationInformation.panel.terminationDate.error.required' | translate
              "
            />
          }
        </div>
      }

      @if (terminationType.value === terminateValue && contractType.value === insuranceValue) {
        <div class="tw-mt-7.5">
          <div class="tw-block tw-items-center sm:tw-inline-flex">
            <label
              class="tw-font-bold hb-group:tw-text-hb-sm hb-group:tw-font-medium"
              for="input-termination-information-termination-reason"
              >{{
                'screens.terminationInformation.panel.terminationReason.label' | translate
              }}</label
            >
            <ia-tooltip
              colorClass="tw-text-gray hb-group:tw-text-midnight-green hb-group:tw-w-5 hb-group:tw-h-5"
              tooltipContainerClass="tw-border tw-border-platinum tw-absolute tw--left-8 tw-w-56 tw-rounded-md tw-bg-white tw-px-4 tw-py-5 tw-text-left tw-text-sm tw-text-gray"
              class="tw-ml-2.5"
            >
              {{ 'screens.terminationInformation.panel.terminationReason.tooltip' | translate }}
            </ia-tooltip>
          </div>
          <ia-listbox2
            [placeholder]="
              'screens.terminationInformation.panel.terminationReason.placeholder' | translate
            "
            class="tw-mt-2.5 tw-w-full hb-group:tw-mt-0 hb-group:tw-flex hb-group:tw-w-full hb-group:tw-items-center hb-group:tw-justify-center hb-group:tw-rounded-xl hb-group:tw-border hb-group:tw-border-silver hb-group:tw-p-3 hb-group:tw-text-hb-md md:tw-w-75 hb-group:md:tw-w-1/2"
            [ngClass]="{ 'tw-text-gray': !terminationReason.value }"
            formControlName="terminationReason"
          >
            @for (item of (groundsList$ | async) || []; track $index) {
              <ia-listbox2-option [value]="item">
                {{ item }}
              </ia-listbox2-option>
            }
          </ia-listbox2>
          @if (terminationReason.touched && terminationReason.hasError('required')) {
            <ia-resil-contrats-error-message
              [message]="
                'screens.terminationInformation.panel.terminationReason.error.required' | translate
              "
            />
          }
        </div>
      }

      @if (contractType.value === insuranceValue && terminationReason.value === other) {
        <div class="tw-mt-7.5">
          <div class="tw-block tw-items-center sm:tw-inline-flex">
            <label
              class="tw-font-bold hb-group:tw-text-hb-sm hb-group:tw-font-medium"
              for="input-termination-information-other-reason"
              >{{ 'screens.terminationInformation.panel.otherReason.label' | translate }}</label
            >
            <ia-tooltip
              colorClass="tw-text-gray hb-group:tw-text-midnight-green hb-group:tw-w-5 hb-group:tw-h-5"
              tooltipContainerClass="tw-border tw-border-platinum tw-absolute tw--left-8 tw-w-56 tw-rounded-md tw-bg-white tw-px-4 tw-py-5 tw-text-left tw-text-sm tw-text-gray"
              class="tw-ml-2.5"
            >
              {{ 'screens.terminationInformation.panel.otherReason.tooltip' | translate }}
            </ia-tooltip>
          </div>
          <input
            [error]="otherReason!.touched && otherReason!.invalid"
            iaInput
            id="input-termination-information-other-reason"
            data-test-id="input-termination-information-other-reason"
            class="tw-w-full focus-visible:focus-visible:tw-outline-none hb-group:tw-mt-0 hb-group:tw-w-full md:tw-w-75 hb-group:md:tw-w-1/2"
            formControlName="otherReason"
            mask="A*"
            [patterns]="specialCharactersNotAllowed"
            [dropSpecialCharacters]="false"
            [placeholder]="
              'screens.terminationInformation.panel.otherReason.placeholder' | translate
            "
          />
          @if (otherReason.touched && otherReason.hasError('required')) {
            <ia-resil-contrats-error-message
              [message]="
                'screens.terminationInformation.panel.otherReason.error.required' | translate
              "
            />
          }
        </div>
      }
    </form>
  </div>
</ia-panel>

<div class="tw-mt-5 tw-flex tw-flex-col tw-items-center tw-justify-end tw-gap-4 md:tw-flex-row">
  <button
    (click)="onPrevious()"
    [isProcessing]="false"
    class="tw-h-10.5 tw-font-semibold hb-group:tw-rounded-3xl"
    iaButton
    id="link-termination-information-previous"
    data-test-id="link-termination-information-previous"
    size="large"
    type="button"
    variant="secondary"
  >
    {{ 'screens.personalInformation.button.previous' | translate }}
  </button>
  <button
    (click)="onNext()"
    [isProcessing]="false"
    class="tw-mt-4 tw-h-10.5 tw-font-semibold hb-group:tw-rounded-3xl md:tw-mt-0"
    iaButton
    id="link-termination-information-next"
    data-test-id="link-termination-information-next"
    size="large"
    type="button"
    variant="primary"
    [disabled]="!terminationInformationForm.valid"
  >
    {{ 'screens.personalInformation.button.next' | translate }}
  </button>
</div>
